import { Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

export const IconErrorFill = (props: IconProps) => {
  const { size = 16, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      color={color ?? 'black'}
      {...otherProps}
    >
      <Path
        fill="currentColor"
        d="M12 2.1c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10Zm1 15h-2v-2h2v2Zm0-4h-2v-6h2v6Z"
      />
    </Svg>
  );
};
